module.exports = __webpack_public_path__ + "assets/img/bigcat5.f4561db4.png";